import { FormControl, InputProps } from "@mui/material";
import styles from "./HolzfinderInputLabled.module.css";
import { MediumText } from "components/typography";
import HolzfinderDateInputWithoutTime from "./HolzfinderDateInputWithoutTime";

// export interface HolzfinderInputProps extends BaseTextFieldProps {
//   onChange: any;
// }
interface BaseTextFieldPropsWithInputProps extends InputProps {
  InputProps?: any;
  onChange?: any;
  onValid?: (valid: boolean) => void;
  pattern?: any;
  label?: string;
  value: string;
  disablePast?: boolean;
}


export default function HolzfinderInputLabled(props: BaseTextFieldPropsWithInputProps) {
  const { label } = props;
  const propsWithoutLabel = { ...props };
  delete propsWithoutLabel.label;
  delete propsWithoutLabel.sx;
  return (
    <FormControl
        sx={{
          marginRight: { xs: 1, md: 6 },
          width: "100%",
        }}
        className={styles.form}
      >
        <MediumText>{label}</MediumText>
        <HolzfinderDateInputWithoutTime
          value={props.value}
          onChange={props.onChange}
          onValid={props.onValid}  
          disablePast={props.disablePast}
          hasError={props.error}
        />
        </FormControl>
  );
}